import { createSlice } from '@reduxjs/toolkit'

import { getCustomerAPI } from '@/api/customerApi'

export const NAME = 'customer'

export const createCustomer = ({
  id,
  name,
  status,
  orgNumber,
  vatNumber,
  numberOfEmployees,
  customerHeadId = 0,
  customerHeadName,
  applicationFileId,
  applicationFileName,
  applicationFileCreated,
  contactName,
  contactPhone,
  contactMobile,
  contactEmail,
  address1,
  address2,
  zip,
  city,
  is_subscription_dealer,
}: any) => ({
  id,
  name,
  status,
  orgNumber,
  vatNumber,
  numberOfEmployees,
  customerHeadId,
  customerHeadName,
  applicationFileId,
  applicationFileName,
  applicationFileCreated,
  contactName,
  contactPhone,
  contactMobile,
  contactEmail,
  address1,
  address2,
  zip,
  city,
  is_subscription_dealer,
})
// @ts-ignore
export const fetchCustomer = id => async (dispatch, getState) => {
  const isPending = getIsPending(getState())
  if (isPending) return

  dispatch(loadPending())

  try {
    const result = await getCustomerAPI(id)
    dispatch(loadSuccess(result))
  } catch (error) {
    dispatch(loadFailure('Could not load customer'))
  }
}

const initialState = {
  pending: false,
  isDataLoaded: false,
  error: undefined,
  customer: undefined,
  frameAgreement: undefined,
}

const { actions, reducer } = createSlice({
  name: NAME,
  initialState,
  reducers: {
    loadPending: state => {
      state.error = undefined
      state.pending = true
    },
    loadSuccess: (state, { payload: customer }) => {
      state.pending = false
      state.isDataLoaded = true
      state.customer = customer
    },
    loadFailure: (state, { payload: error }) => {
      state.pending = false
      state.isDataLoaded = true
      state.error = error
    },
    setFrameAgreement: (state, { payload: frameAgreement }) => {
      state.frameAgreement = frameAgreement
    },
    resetCustomerApplicationFileId: state => {
      // @ts-ignore
      state.customer.applicationFileId = null
    },

    reset: () => ({
      ...initialState,
    }),
  },
})

export const {
  loadPending,
  loadSuccess,
  loadFailure,
  setFrameAgreement,
  reset,
  resetCustomerApplicationFileId,
} = actions

export default reducer

const getState = (state: any) => state[NAME]

export const getIsPending = (state: any) => getState(state).pending
export const getError = (state: any) => getState(state).error
// @ts-ignore
export const getIsDataLoaded = (state, customerId) =>
  getState(state).isDataLoaded && getCustomerId(state) === customerId

export const getCustomer = (state: any) => getState(state).customer

export const getCustomerName = (state: any) => getCustomer(state).name
export const getCustomerOrgNumber = (state: any) => getCustomer(state).orgNumber
export const getCustomerVatNumber = (state: any) => getCustomer(state).vatNumber
export const getNumberOfEmployees = (state: any) => getCustomer(state).numberOfEmployees

export const getCustomerId = (state: any) => getCustomer(state).id
export const getCustomerStatus = (state: any) => getCustomer(state).status

export const getCustomerApplicationFileId = (state: any) => getCustomer(state).applicationFileId
export const getCustomerApplicationFileName = (state: any) => getCustomer(state).applicationFileName
export const getCustomerApplicationFileCreated = (state: any) =>
  getCustomer(state).applicationFileCreated

export const getCustomerContactName = (state: any) => getCustomer(state).contactName
export const getCustomerContactPhone = (state: any) => getCustomer(state).contactPhone
export const getCustomerContactMobile = (state: any) => getCustomer(state).contactMobile
export const getCustomerContactEmail = (state: any) => getCustomer(state).contactEmail

export const getCustomerAddress1 = (state: any) => getCustomer(state).address1
export const getCustomerAddress2 = (state: any) => getCustomer(state).address2
export const getCustomerZip = (state: any) => getCustomer(state).zip
export const getCustomerCity = (state: any) => getCustomer(state).city

export const getFrameAgreement = (state: any) => getState(state).frameAgreement || {}
export const getVendorRates = (state: any) => getFrameAgreement(state)?.vendor_rates || []
export const getApplications = (state: any) => getFrameAgreement(state)?.credit_applications || []
export const getInsuranceTypes = (state: any) => getFrameAgreement(state)?.insurance_types || []

export const getCustomerIsSubscriptionDealer = (state: any) =>
  getCustomer(state).is_subscription_dealer

export const getVendorRateTypes = (state: any) => [
  // @ts-ignore
  ...new Set(getVendorRates(state).map(vendorRate => vendorRate.product_type)),
]
// @ts-ignore
export const getVendorRatesForType = (state, productType) =>
  // @ts-ignore
  getVendorRates(state).filter(vendorRate => vendorRate.product_type === productType)
